import { useMutation, useQueryClient } from "@tanstack/react-query";

import { revokeOtherSessions } from "./api";
import type { RevokeOthersResponse } from "./api";

// «Завершить все сессии, кроме текущей». Инвалидируем список — в таблице
// останется только текущая. Токены других устройств станут невалидны
// немедленно (их следующий запрос → 401).
export function useRevokeOtherSessions(): ReturnType<
  typeof useMutation<RevokeOthersResponse, Error, void>
> {
  const queryClient = useQueryClient();
  return useMutation<RevokeOthersResponse, Error, void>({
    mutationFn: () => revokeOtherSessions(),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["sessions"],
      });
    },
  });
}
